import { User } from '../../domains/app';
import { Space } from '../Spaces/spaces';

export interface QuestionnairesContainerState {
  list: Questionnaire[];
  page: number;
  pageSize: number;
  total: number;
  isFetching: boolean;
  search: string;
  activeQuestionnaire?: Questionnaire;
  showQuestionnaireDetails: boolean;
  seriesToDelete: string[];
}

export interface Questionnaire {
  id?: string;
  name: string;
  text: string;
  description: string;
  personId: string;
  person?: User;
  languageId?: string;
  languages?: Language[];
  isPublished: boolean;
  date?: string | Date;
  questionSeries: QuestionSeries[];
  checked?: boolean;
}

export interface QuestionSeries {
  id?: string;
  localizedName?: string;
  name: string;
  postText?: string | null;
  preText?: string | null;
  personId: string;
  questions: Question[];
}

export interface Question {
  answerType: AnswerType;
  answers: Answer[];
  code?: any;
  id?: string;
  preText: string | null;
  question: string;
  text?: string;
  indexOf?: any;
}

export interface Answer {
  id?: string;
  score: number;
  text: string;
  rangeStep?: number;
  selected?: boolean;
}

export enum AnswerType {
  RadioButton = 0,
  CheckBox = 1,
  Range = 2,
}

export interface Language {
  name: string;
  code: string;
  id: string;
}

export interface QuestionnaireRequest {
  id: string;
  completed: string | Date;
  requested: string | Date;
  isCompleted: boolean;
  person: User;
  sentByPerson: User;
  questionnaire: Questionnaire;
  space: Space;
}

export interface FilledAnswer {
  questionId: string;
  answerId: string;
  score: number;
}
